import { ScrollContainer } from '~/components/atoms/ScrollContainer';
import LoginHeader from '~/components/LoginHeader';
import { MenuViewHeader } from '~/components/MenuViewHeader';

import styles from './LoginRequiredPopup.module.scss';

export default function LoginRequiredPopup(): JSX.Element {
  return (
    <ScrollContainer>
      <div className={styles.LoginRequiredPopup}>
        <MenuViewHeader title="" />
        <LoginHeader replace />
      </div>
    </ScrollContainer>
  );
}
